export default __webpack_public_path__ + "static/media/gel-buffer-liquid-1.e1b4aa1e.svg";